import { render, staticRenderFns } from "./MsjXhr.vue?vue&type=template&id=f3775c50"
import script from "./MsjXhr.vue?vue&type=script&lang=js"
export * from "./MsjXhr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports